var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value,"placeholder":"请选择展示形式","multiple":_vm.multiple},on:{"input":function($event){return _vm.$emit('input', $event)}}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.code}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }